import { MockPromise } from "./MockPromise";

class MockPromiseWrapper<T> {
    id: string;
    name: string;
    promise: Promise<T> | MockPromise<T>;
    resolve: (value: T) => void;
    progress: (value: number) => void;
    reject?: (error: Error) => void;
    finally?: () => void;
    callMade: boolean;

    constructor(id: string, name: string, shouldRelease?: () => void) {
        this.id = id;
        this.name = name;
        this.resolve = (value: T) => {};
        this.progress = (value: number) => {};
        this.reject = (error: Error) => {};
        this.finally = () => {};
        this.promise = new MockPromise(
            name,
            (resolve, progress, reject, completed) => {
                this.resolve = resolve;
                this.progress = progress;
                this.reject = reject;
                this.finally = completed;
            },
            shouldRelease,
        );
        this.callMade = false;
    }
}

export { MockPromiseWrapper };
